import Image from 'next/image';
import { useEffect, useRef } from 'react';
import { TabSelectorStyle } from '../../../styles/components/common/ui';

export interface ITabSelectorProps {
  tabs: { name: string; label: string; iconPath: string }[];
  activeTabName?: string;
  onTabButtonClick: (tabName: string) => void;
}

const TabSelector = (props: ITabSelectorProps) => {
  const selectorRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const selector = selectorRef.current;
    const active = selector?.querySelector<HTMLElement>(
      '[aria-pressed="true"]'
    );
    if (!selector || !active) return;
    const activeBounds = active.getBoundingClientRect();
    const bounds = selector.getBoundingClientRect();
    if (activeBounds.right > bounds.right)
      selector.scrollLeft += activeBounds.right - bounds.right;
    else if (activeBounds.left < bounds.left)
      selector.scrollLeft -= bounds.left - activeBounds.left;
  }, [props.activeTabName]);
  return (
    <div ref={selectorRef} className={TabSelectorStyle['tab-selector']}>
      {props.tabs.map((tab, index) => {
        return (
          <button
            type="button"
            aria-pressed={tab.name === props.activeTabName}
            key={index}
            onClick={() => props.onTabButtonClick(tab.name)}
            className={`${TabSelectorStyle['tab-button']} ${
              tab.name === props.activeTabName
                ? TabSelectorStyle['is-active']
                : null
            }`}>
            <Image
              quality={90}
              src={tab.iconPath}
              alt=""
              width={16}
              height={16}
            />
            <span>{tab.label}</span>
          </button>
        );
      })}
      <div className={TabSelectorStyle['tab-button']}></div>
    </div>
  );
};

export default TabSelector;
